require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-align-columns.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-align-columns");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-align-columns!./.cache/json/coding-interview-prep-rosetta-code-align-columns.json
// module id = 1836
// module chunks = 231608221292675